import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import MineHeader from "./MineHeader";
import LiveClock from "./LiveClock";
import { useNavigate } from "react-router-dom";
const base_url = process.env.REACT_APP_API_URL;

const MineBody = () => {
  const minAmount = 1;
  const maxAmount = 10000;
  const boxes = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24,
  ];
  const totalBoxes = boxes.length;
  const minMines = 1;
  const maxMines = 24;

  const token = localStorage.getItem("token");
  const [walletBalance, setWalletBalance] = useState(0);
  const [userId, setUserId] = useState(null);
  const [gameId, setGameId] = useState(null);
  const [cashOutStatus, setCashOutStatus] = useState(false);
  const [betStatus, setBetStatus] = useState(false);
  const [betAmount, setBetAmount] = useState(1);
  const [winAmount, setWinAmount] = useState(0);
  const [selectedBoxes, setSelectedBoxes] = useState([]);
  const [selectedBoxesById, setSelectedBoxesById] = useState([]);
  const [gameResultById, setGameResultById] = useState({});
  const [risk, setRisk] = useState(0);
  const [multipler, setMultipler] = useState(1);
  const [possiblePayout, setPossiblePayout] = useState(0);
  const [mines, setMines] = useState(3);
  const [isLoading, setIsLoading] = useState(false);
  const [gameStarted, setGameStarted] = useState(false);
  const [revealedBoxes, setRevealedBoxes] = useState({});
  const [showCashout, setShowCashout] = useState(false);
  const [bombIndices, setBombIndices] = useState([]);
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [autoBet, setAutoBet] = useState(false);
  const [isOpenModal1, setIsOpenModal1] = useState(false);
  const [isOpenModal2, setIsOpenModal2] = useState(false);
  const [betHistory, setBetHistory] = useState([]);
  const [multiplierSettings, setMultiplierSettings] = useState(null);
  const navigate = useNavigate();

  const audioFiles = {
    bet: new Audio("/mines/audio/bet.mp3"),
    cashout: new Audio("/mines/audio/cashout.mp3"),
    diamond: new Audio("/mines/audio/diamond.mp3"),
    bomb: new Audio("/mines/audio/bomb.mp3"),
    click: new Audio("/mines/audio/click.mp3"),
  };

  useEffect(() => {
    Object.values(audioFiles).forEach((audio) => {
      audio.preload = "auto";
      audio.load();
      audio.onerror = () => console.error(`Failed to load audio: ${audio.src}`);
    });
  }, []);

  const fetchUserDetails = async () => {
    try {
      const response = await fetch(
        `${base_url}/api/get_user_detail_mines_game`,
        {
          method: "GET",
          headers: {
            Authorization: token,
          },
        },
      );

      if (response.status >= 300 && response.status < 400) {
        toast.error("Please log in to continue.");
        window.location.href = "/login";
        return;
      }

      if (!response.ok)
        throw new Error(
          `Network response was not ok: ${response.status} ${response.statusText}`,
        );

      const result = await response.json();
      if (result.isSuccess && result.data) {
        const money = parseFloat(result.data.money);
        setWalletBalance(isNaN(money) ? 0 : Math.floor(money));
        setUserId(result.data.username || null);
        setGameId(result.data.currentGameId || null);
        setBetHistory(result.userBetResult || []);
        setMultiplierSettings(result.gameSettings || []);
        const initialSettings = result.gameSettings.find(
          (s) => s.gameId === mines,
        ) || { startPercentage: 1 };
        setMultipler(Number(initialSettings.startPercentage.toFixed(2)));
        setPossiblePayout(
          Number((betAmount * initialSettings.startPercentage).toFixed(2)),
        );
      } else {
        console.error("Failed to fetch user details.");
      }
    } catch (error) {
      console.error("Fetch user details error:", error);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  useEffect(() => {
    const calculatedRisk = (mines / totalBoxes) * 100;
    setRisk(Math.round(calculatedRisk));

    if (multiplierSettings) {
      const settings = multiplierSettings.find((s) => s.gameId === mines) || {
        startPercentage: 1,
        step: 0,
        endPercentage: 1,
      };
      const diamondsRevealed = selectedBoxes.filter(
        (box) => !bombIndices.includes(box),
      ).length;
      let newMultipler = settings.startPercentage;
      if (diamondsRevealed > 0) {
        newMultipler = Math.min(
          settings.startPercentage + diamondsRevealed * settings.step,
          settings.endPercentage,
        );
      }
      setMultipler(Number(newMultipler.toFixed(2)));
      setPossiblePayout(Number((betAmount * newMultipler).toFixed(2)));
    }
  }, [selectedBoxes, betAmount, mines, bombIndices, multiplierSettings]);

  useEffect(() => {
    let intervalId;
    if (autoBet && !gameStarted && !isLoading) {
      intervalId = setInterval(() => {
        betPlace();
      }, 3000);
    }
    return () => clearInterval(intervalId);
  }, [autoBet, gameStarted, isLoading, betAmount, mines, userId, gameId]);

  function minusBetAmount() {
    playSound(audioFiles.click);
    if (gameStarted === true) {
      toast.error(
        "You cannot change the bet amount while the game is in progress.",
      );
      return;
    }
    let amount = betAmount - 1;
    if (amount < minAmount) amount = minAmount;
    setBetAmount(amount);
  }

  function plusBetAmount() {
    playSound(audioFiles.click);
    if (gameStarted === true) {
      toast.error(
        "You cannot change the bet amount while the game is in progress.",
      );
      return;
    }
    let amount = betAmount + 1;
    if (amount > maxAmount) amount = maxAmount;
    setBetAmount(amount);
  }

  function minBetAmount() {
    playSound(audioFiles.click);
    if (gameStarted === true) {
      toast.error(
        "You cannot change the bet amount while the game is in progress.",
      );
      return;
    }
    setBetAmount(minAmount);
  }

  function maxBetAmount() {
    playSound(audioFiles.click);
    if (gameStarted === true) {
      toast.error(
        "You cannot change the bet amount while the game is in progress.",
      );
      return;
    }
    setBetAmount(maxAmount);
  }

  function toggleSound() {
    setSoundEnabled((prev) => !prev);
  }

  function playSound(audio) {
    if (soundEnabled) {
      try {
        audio.currentTime = 0;
        audio
          .play()
          .catch((error) =>
            console.error(`Error playing ${audio.src}:`, error),
          );
      } catch (error) {
        console.error(`Error playing ${audio.src}:`, error);
      }
    }
  }

  function boxItem(item) {
    if (!gameStarted || revealedBoxes[item]) return;

    const newSelectedBoxes = [...new Set([...selectedBoxes, item])];
    setSelectedBoxes(newSelectedBoxes);
    setShowCashout(true);

    const isBomb = bombIndices.includes(item);
    if (isBomb) {
      playSound(audioFiles.bomb);
      setGameStarted(false);
      setShowCashout(false);
      setBetStatus(false);
      const result = {};
      boxes.forEach((box) => {
        result[box] = bombIndices.includes(box) ? "B" : "D";
      });
      setRevealedBoxes(result);
      saveToResultDataDatabase(0, result, newSelectedBoxes, 2);
      setTimeout(() => {
        setRevealedBoxes({});
        const settings = multiplierSettings.find((s) => s.gameId === mines) || {
          startPercentage: 1,
        };
        setMultipler(Number(settings.startPercentage.toFixed(2)));
        setPossiblePayout(0);
        setSelectedBoxes([]);
      }, 3000);
    } else {
      document.getElementById(
        "gameItem__inner_multiplier" + item,
      ).style.display = "flex";
      setTimeout(() => {
        document.getElementById(
          "gameItem__inner_multiplier" + item,
        ).style.display = "none";
      }, 1000);
      playSound(audioFiles.diamond);
      setRevealedBoxes((prev) => ({ ...prev, [item]: "D" }));
      const diamondsRevealed =
        Object.keys(revealedBoxes).filter((key) => revealedBoxes[key] === "D")
          .length + 1;
      if (diamondsRevealed === totalBoxes - mines) {
        const calWinAmount = betAmount * multipler;
        const result = { ...revealedBoxes, [item]: "D" };
        saveToResultDataDatabase(calWinAmount, result, newSelectedBoxes, 1);
        setGameStarted(false);
        setShowCashout(false);
        setTimeout(() => resetGame(), 1000);
      }
    }
  }

  const betPlace = async () => {
    if (!userId) {
      toast.error("Please Login First!");
      return;
    }

    if (betAmount < minAmount || betAmount > maxAmount) {
      toast.error(`Bet amount must be between ${minAmount} and ${maxAmount}.`);
      return;
    }

    if (betAmount > walletBalance) {
      toast.error("Insufficient balance to place the bet.");
      return;
    }

    if (gameStarted) {
      toast.error("Game already in progress. Please finish or reset.");
      return;
    }

    if (betStatus) {
      toast.error("Bet already in progress. Please wait for finish.");
      return;
    }
    setBetStatus(true);
    setIsLoading(true);
    try {
      const newBombIndices = [];
      while (newBombIndices.length < mines) {
        const randomIndex = Math.floor(Math.random() * boxes.length);
        if (!newBombIndices.includes(randomIndex))
          newBombIndices.push(randomIndex);
      }
      setBombIndices(newBombIndices);

      const response = await fetch(`${base_url}/api/mines_game_bet`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ betAmount, gameId, userId, mines }),
      });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const result = await response.json();

      if (result.success === true) {
        playSound(audioFiles.bet);
        const money =
          parseFloat(result.data.money) || walletBalance - betAmount;
        setWalletBalance(Math.floor(money));
        setGameStarted(true);
        setRevealedBoxes({});
        const settings = multiplierSettings.find((s) => s.gameId === mines) || {
          startPercentage: 1,
        };
        setMultipler(Number(settings.startPercentage.toFixed(2)));
        setPossiblePayout(
          Number((betAmount * settings.startPercentage).toFixed(2)),
        );
        toast.success(result.message);
      } else {
        toast.error(result.message || "Failed to place bet.");
      }
    } catch (error) {
      toast.error(`Error placing bet: ${error.message}`);
      console.error("Bet placement error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  function betNow() {
    betPlace();
  }

  async function saveToResultDataDatabase(
    winAmount,
    result,
    selectedBoxes,
    status,
  ) {
    if (gameId === undefined || gameId === null) {
      toast.error("Game ID is missing. Please start a new game.");
      return;
    }

    if (userId === undefined || userId === null) {
      toast.error("User ID is missing. Please log in again.");
      return;
    }

    if (multipler === undefined || multipler === null) {
      toast.error("Multipler is not set. Please try again.");
      return;
    }

    const payload = {
      betAmount,
      mines,
      winAmount: Number(winAmount.toFixed(2)),
      gameId,
      userId,
      result,
      selectedBoxes,
      status,
      multipler: Number(multipler.toFixed(2)),
    };

    console.log("Saving to database with payload:", payload);

    try {
      const response = await fetch(`${base_url}/api/mines_game_cashout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      if (data.success === true) {
        setGameId(data.data.gameId || null);
        const money = parseFloat(data.data.money) || walletBalance + winAmount;
        setWalletBalance(Math.floor(money));

        if (winAmount > 0) {
          playSound(audioFiles.cashout);
          toast.success(
            `Cashed out successfully! Won ₹${winAmount.toFixed(2)}`,
          );
        }

        fetchUserDetails();

        setWinAmount(Number(winAmount.toFixed(2)));
        setCashOutStatus(true);
        setTimeout(() => {
          resetGame();
        }, 3000);
      } else {
        toast.error(data.message || "Failed to save game data.");
      }
    } catch (error) {
      toast.error(`Error saving game data: ${error.message}`);
      console.error("Save to database error:", error);
    }
  }

  function cashout() {
    if (selectedBoxes.length === 0) {
      toast.error("Please select at least one box before cashing out.");
      return;
    }

    if (cashOutStatus) {
      toast.error("Cashout already in progress. Please wait for finish.");
      return;
    }

    const calWinAmount = betAmount * multipler;
    const result = {};
    boxes.forEach((box) => {
      result[box] = bombIndices.includes(box) ? "B" : "D";
    });

    saveToResultDataDatabase(calWinAmount, result, selectedBoxes, 1);
  }

  function autoBetActive() {
    playSound(audioFiles.click);
    setAutoBet((prev) => !prev);
  }

  function settings() {
    playSound(audioFiles.click);
    setIsOpenModal1((prev) => !prev);
  }

  function settings2() {
    playSound(audioFiles.click);
    setIsOpenModal2(false);
    setIsOpenModal1(true);
  }

  function goBack() {
    playSound(audioFiles.click);
    setIsOpenModal1(false);
  }

  function goBack2() {
    playSound(audioFiles.click);
    setIsOpenModal2(false);
    setIsOpenModal1(true);
  }

  function randomBox() {
    if (!betStatus) {
      toast.error("Please placed bet first.");
      return;
    }

    if (!gameStarted) {
      toast.error("Game not started yet.");
      return;
    }

    // filter boxes that are not revealed yet
    const availableBoxes = boxes.filter((item) => !revealedBoxes[item]);

    if (availableBoxes.length === 0) {
      toast.error("No boxes left to open!");
      return;
    }

    // pick a random one
    const randomIndex = Math.floor(Math.random() * availableBoxes.length);
    const randomItem = availableBoxes[randomIndex];

    // simulate click
    boxItem(randomItem);
  }

  function resetGame() {
    setGameStarted(false);
    setShowCashout(false);
    setBetStatus(false);
    setCashOutStatus(false);
    setRevealedBoxes({});
    setSelectedBoxes([]);
    setBombIndices([]);
    const settings = multiplierSettings.find((s) => s.gameId === mines) || {
      startPercentage: 1,
    };
    setMultipler(Number(settings.startPercentage.toFixed(2)));
    setPossiblePayout(0);
    setWinAmount(0);
  }

  const isRevealPhase = !gameStarted && Object.keys(revealedBoxes).length > 0;

  const boxStyle = (item) => {
    if (isRevealPhase) {
      return {
        pointerEvents: "none",
        opacity: selectedBoxes.includes(item) ? 1 : 0.25,
      };
    }
    if (!gameStarted) {
      return { pointerEvents: "none", opacity: 0.5 };
    }
    return revealedBoxes[item] ? { opacity: 1 } : { opacity: 0.5 };
  };

  function betDetailById(betId) {
    return () => {
      playSound(audioFiles.click);

      let betHistoryDetails = betHistory.find((bet) => bet.id === betId);

      const selectedBoxes = betHistoryDetails.selected_box
        ? JSON.parse(betHistoryDetails.selected_box)
        : [];
      const gameResult = betHistoryDetails.game_result
        ? JSON.parse(betHistoryDetails.game_result)
        : {};

      setSelectedBoxesById(selectedBoxes || []);
      setGameResultById(gameResult || {});

      setIsOpenModal1(false);
      setIsOpenModal2(true);
    };
  }

  const boxStyle2 = (item) => {
    return {
      opacity: selectedBoxesById.includes(item) ? 1 : 0.4,
    };
  };

  return (
    <>
      <MineHeader />
      <div id="app">
        <div
          id="ModuleLayoutDiv"
          className="header--CucH5"
          style={{
            background:
              "linear-gradient(rgba(34, 34, 34, 0.5) 0%, rgba(34, 34, 34, 0) 100%)",
          }}
        />
        <div data-track="balance" className="balance--Kjiqa">
          <div className="balanceTitle--JnSFJ">Balance:</div>
          <i className="fa-solid fa-credit-card" />₹
          <span className="balanceSum--_ab3Z">{walletBalance}</span>
        </div>
        <div className="name--TP6Ls">Thixpro Games • 1Tap Mines</div>
        <div className="time--tHxDp">
          <LiveClock />
        </div>
        <div id="" className="labels--ydaRJ" />
        <div id="" className="headerBtns--edvax">
          <div data-track="settings" className="icon--k9yLr" onClick={settings}>
            <div className="iconImage--_j4Q6 iconImageSettings--iRiUL" />
          </div>
          <div data-track="sound" className="icon--k9yLr" onClick={toggleSound}>
            <div
              className={`iconImage--_j4Q6 iconImageSound--P6lkE ${
                soundEnabled ? "" : "_off"
              }`}
              title={soundEnabled ? "Mute Sound" : "Enable Sound"}
            />
          </div>
          <div data-track="fastplay" className="icon--k9yLr">
            <div className="iconImage--_j4Q6 iconImageQuickGame--v3_iQ _off" />
          </div>
          <div data-track="universe" className="icon--k9yLr">
            <span className="iconActiveIndicator--CMTO4" />
            <div className="iconTurboUniverse--Of1Ih" />
          </div>
          <div data-track="universe" className="icon--k9yLr">
            <div className="settingHeaderModalBack--qPVfc" onClick={goBack}>
              <i className="fa-solid fa-arrow-left" />
              <span></span>
            </div>
          </div>
        </div>
        <div id="observeElementTree" className="wrap mines">
          <div className="mines__bg" />
          <div className="mines__inner">
            <div className="game _portrait">
              <div className="game__header">
                <p className="game__headerRisk">
                  Risk <span>{risk}%</span>
                </p>
                <p className="game__headerBombsOnField">
                  Mines <span>{mines}</span>
                  <span className="_bomb" />
                </p>
              </div>
              <div className="game__inner">
                <div className={`win ${winAmount <= 0 ? "remove" : ""}`}>
                  <div className="win__label">You Win</div>
                  <div className="win__amount">₹{winAmount}</div>
                  <div className="win__separator"></div>
                  <div className="win__coefficient">
                    x{multipler.toFixed(2)}
                  </div>
                </div>
                {boxes.map((item) => (
                  <div
                    className={`gameItem _${item} ${
                      !gameStarted ? "disabled" : ""
                    } ${
                      revealedBoxes[item]
                        ? revealedBoxes[item] === "B"
                          ? "bomb"
                          : "diamond"
                        : ""
                    }`}
                    key={item}
                    onClick={() => boxItem(item)}
                    style={boxStyle(item)}
                  >
                    <div className="gameItem__inner" />
                    {revealedBoxes[item] && (
                      <div
                        className={`gameItem__solved ${
                          revealedBoxes[item] === "D"
                            ? "gameItem__diamond"
                            : "gameItem__bomb"
                        }`}
                        style={{
                          backgroundImage: `url(/mines/images/${
                            revealedBoxes[item] === "D"
                              ? "blue-diamond.svg"
                              : "bomb.svg"
                          })`,
                        }}
                      />
                    )}

                    <div
                      className="gameItem__inner_multiplier"
                      id={"gameItem__inner_multiplier" + item}
                    >
                      <h2>x{multipler}</h2>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="control">
              <div className="logo" />
              <div className="control__header">
                <div className="control__crystall _green">
                  <div className="control__crystallInner" />
                  <span>
                    +
                    <div style={{ display: "inline-flex", overflow: "hidden" }}>
                      <style
                        dangerouslySetInnerHTML={{
                          __html:
                            "\n                                        @keyframes odometer {\n                                            from {\n                                                transform: translateY(0);\n                                            }\n\n                                            to {\n                                                transform: translateY(100%);\n                                            }\n                                        }\n                                    ",
                        }}
                      />
                      <div style={{ position: "relative" }}>
                        {Math.round(risk)}
                        <span
                          style={{
                            position: "absolute",
                            inset: 0,
                            transform: "translateY(-100%)",
                          }}
                        >
                          {Math.round(risk)}
                        </span>
                      </div>
                    </div>
                    %
                  </span>
                </div>
                <div className="control__center">
                  <div className="_multiplier">
                    <p>Multiplier</p>
                    <div style={{ display: "inline-flex", overflow: "hidden" }}>
                      <style
                        dangerouslySetInnerHTML={{
                          __html:
                            "\n                                        @keyframes odometer {\n                                            from {\n                                                transform: translateY(0);\n                                            }\n\n                                            to {\n                                                transform: translateY(100%);\n                                            }\n                                        }\n                                    ",
                        }}
                      />
                      <div style={{ position: "relative" }}>
                        x
                        <span
                          style={{
                            position: "absolute",
                            inset: 0,
                            transform: "translateY(-100%)",
                          }}
                        >
                          x
                        </span>
                      </div>
                      <div style={{ position: "relative" }}>
                        {multipler.toFixed(2)}
                        <span
                          style={{
                            position: "absolute",
                            inset: 0,
                            transform: "translateY(-100%)",
                          }}
                        >
                          {multipler.toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="_multiplier">
                    <p>Possible Payout</p>
                    <div style={{ display: "inline-flex", overflow: "hidden" }}>
                      <style
                        dangerouslySetInnerHTML={{
                          __html:
                            "\n                                        @keyframes odometer {\n                                            from {\n                                                transform: translateY(0);\n                                            }\n\n                                            to {\n                                                transform: translateY(100%);\n                                            }\n                                        }\n                                    ",
                        }}
                      />
                      {possiblePayout
                        .toString()
                        .split("")
                        .map((char, index) => (
                          <div key={index} style={{ position: "relative" }}>
                            {char}
                            <span
                              style={{
                                position: "absolute",
                                inset: 0,
                                transform: "translateY(-100%)",
                              }}
                            >
                              {char}
                            </span>
                          </div>
                        ))}
                      <div style={{ position: "relative" }}>
                        {" "}
                        <span
                          style={{
                            position: "absolute",
                            inset: 0,
                            transform: "translateY(-100%)",
                          }}
                        ></span>
                      </div>
                      <div style={{ position: "relative" }}>
                        ₹
                        <span
                          style={{
                            position: "absolute",
                            inset: 0,
                            transform: "translateY(-100%)",
                          }}
                        >
                          ₹
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="control__crystall _beige">
                  <div className="control__crystallInner" />
                  <span>
                    +
                    <div style={{ display: "inline-flex", overflow: "hidden" }}>
                      <style
                        dangerouslySetInnerHTML={{
                          __html:
                            "\n                                        @keyframes odometer {\n                                            from {\n                                                transform: translateY(0);\n                                            }\n\n                                            to {\n                                                transform: translateY(100%);\n                                            }\n                                        }\n                                    ",
                        }}
                      />
                      <div style={{ position: "relative" }}>
                        0
                        <span
                          style={{
                            position: "absolute",
                            inset: 0,
                            transform: "translateY(-100%)",
                          }}
                        >
                          0
                        </span>
                      </div>
                    </div>
                    %
                  </span>
                </div>
              </div>
              <div className="control__amount controlAmount">
                <div className="controlAmount__label">
                  <span>Bet Amount</span>
                  <i
                    className="fa-solid fa-circle-info"
                    title="Max Profit ₹10000"
                  />
                </div>
                <div
                  className="button _small _black _wrapped _max"
                  onClick={maxBetAmount}
                >
                  <div className="layer-bottom" />
                  <div className="layer-top" />
                  <span className="text">max</span>
                </div>
                <div
                  className="button _small _black _wrapped _plus"
                  onClick={plusBetAmount}
                >
                  <div className="layer-bottom" />
                  <div className="layer-top" />
                  <i className="fa-solid fa-plus" />
                </div>
                <div className="controlAmount__center">
                  <input
                    id="bc000ce8-0216-488e-9f76-1252bf4c13ac"
                    type="number"
                    inputMode="decimal"
                    autoComplete="off"
                    spellCheck="false"
                    tabIndex={-1}
                    className="controlAmount__input"
                    value={betAmount}
                    onChange={(e) => {
                      let value = Number(e.target.value);

                      if (isNaN(value)) value = minAmount; // fallback
                      if (value > maxAmount) value = maxAmount;
                      if (value < minAmount) value = minAmount;

                      setBetAmount(value);
                    }}
                    readOnly={gameStarted}
                    max={maxAmount}
                    min={minAmount}
                    maxLength={5}
                  />
                </div>
                <div
                  className="button _small _black _wrapped _minus"
                  onClick={minusBetAmount}
                >
                  <div className="layer-bottom" />
                  <div className="layer-top" />
                  <i className="fa-solid fa-minus" />
                </div>
                <div
                  className="button _small _black _wrapped _min"
                  onClick={minBetAmount}
                >
                  <div className="layer-bottom" />
                  <div className="layer-top" />
                  <span className="text">min</span>
                </div>
              </div>
              <div className="minesSeletBoxDiv">
                <select
                  disabled={gameStarted}
                  value={mines}
                  onChange={(e) => {
                    const newMines = Number(e.target.value);
                    setMines(newMines);
                    const settings = multiplierSettings.find(
                      (s) => s.gameId === newMines,
                    ) || { startPercentage: 1 };
                    setMultipler(Number(settings.startPercentage.toFixed(2)));
                    setPossiblePayout(
                      Number((betAmount * settings.startPercentage).toFixed(2)),
                    );
                  }}
                >
                  {[...Array(maxMines - minMines + 1)].map((_, i) => (
                    <option key={i + minMines} value={i + minMines}>
                      Mines {i + minMines}
                    </option>
                  ))}
                </select>

                <button onClick={randomBox}>Random</button>
              </div>
              <div
                className="control__button"
                onClick={betNow}
                style={{
                  opacity: isLoading || gameStarted ? 0.5 : 1,
                  pointerEvents: isLoading || gameStarted ? "none" : "auto",
                  display: gameStarted ? "none" : "block",
                }}
              >
                <div
                  className="control__buttonInner"
                  style={{ marginTop: "18px" }}
                >
                  Place bet
                </div>
                <div className="control__buttonSeparator" />
                <div className="control__buttonBg" />
              </div>
              {gameStarted && (
                <div className="control__button" onClick={cashout}>
                  <div className="control__buttonInner">Cashout</div>
                  <div className="control__buttonSeparator" />
                  <div className="control__buttonBg" />
                </div>
              )}
              <div className="toggleBtn__container">
                <div
                  className={`toggleBtn ${autoBet ? "_active" : ""}`}
                  onClick={autoBetActive}
                >
                  <div />
                </div>
                <div className="toggleBtn__label">
                  Continue Play{" "}
                  <i
                    className="fa-solid fa-circle-info"
                    title="In 'Continue Play' mode, you can play automatic."
                  />
                </div>
              </div>
            </div>
            {/* <div className="mines__switcher" /> */}
          </div>
        </div>
      </div>
      <div id="modal" className={!isOpenModal1 ? "remove" : ""}>
        <div className="animation--Pf2PO animationOpen--lhuEa">
          <div className="animationInner--O9n3F">
            <div className="tmp--Kw11C">
              <div className="tmpInner--Ya0As tmpInnerBg2--Lkpx_">
                <div className="tmpHeader--Mg7Qe">
                  <div className="settingHeaderModal--zfmus">
                    <div
                      className="settingHeaderModalBack--qPVfc"
                      onClick={goBack}
                    >
                      <i className="fa-solid fa-arrow-left" />
                      <span></span>
                    </div>
                    <div className="settingHeaderModalTitle--gE7Ie">
                      My Bets
                    </div>
                    <div
                      className="settingHeaderModalClose--v6b_6"
                      onClick={settings}
                    >
                      <i className="fa-solid fa-close" />
                    </div>
                  </div>
                </div>
                <div className="tmpContent--qSAU2">
                  <div className="mybets--qoDwl mybetsLoading--mI9ZD">
                    <div className="mybetsHeader--ZUCtB">
                      <div className="mybetsCol--oKfnj">
                        <span>Time</span>
                      </div>
                      <div className="mybetsCol--oKfnj">
                        <span>Bet Amount</span>
                      </div>
                      <div className="mybetsCol--oKfnj">
                        <span>Multiplier</span>
                      </div>
                      <div className="mybetsCol--oKfnj">
                        <span>Payout</span>
                      </div>
                      <div className="mybetsInfo--DkgM6" />
                    </div>
                    {betHistory.map((item) => (
                      <div className="mybetsRow--crXR8" key={item.created_at}>
                        <div className="mybetsRowDefault--CMccs">
                          <div className="mybetsCol--oKfnj">
                            <span>
                              {new Date(item.created_at).toLocaleString()}
                            </span>
                          </div>
                          <div className="mybetsCol--oKfnj">
                            <span>{item.betAmount}</span>
                          </div>
                          <div className="mybetsCol--oKfnj">
                            <span>
                              {item.winAmount > 0 ? item.multipler : "-"}
                            </span>
                          </div>
                          <div className="mybetsCol--oKfnj mybetsColBold--LFXtx">
                            <span>{item.winAmount}</span>
                          </div>
                          <div
                            className="mybetsInfo--DkgM6"
                            onClick={betDetailById(item.id)}
                          >
                            <i className="fa-solid fa-circle-info" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="preloader--u7jOc" />
                </div>
                <div className="tmpFooter--ju5rL">
                  <div>Thixpro Games • 1Tap Mines</div>
                  <div>
                    <LiveClock />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="modal" className={!isOpenModal2 ? "remove" : ""}>
        <div className="animation--Pf2PO animationOpen--lhuEa">
          <div className="animationInner--O9n3F">
            <div className="tmp--Kw11C">
              <div className="tmpInner--Ya0As tmpInnerBg2--Lkpx_">
                <div className="tmpHeader--Mg7Qe">
                  <div className="settingHeaderModal--zfmus">
                    <div
                      className="settingHeaderModalBack--qPVfc"
                      onClick={goBack2}
                    >
                      <i className="fa-solid fa-arrow-left" />
                      <span></span>
                    </div>
                    <div className="settingHeaderModalTitle--gE7Ie">
                      Bet Details
                    </div>
                    <div
                      className="settingHeaderModalClose--v6b_6"
                      onClick={settings2}
                    >
                      <i className="fa-solid fa-close" />
                    </div>
                  </div>
                </div>
                <div
                  className="tmpContent--qSAU2"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <div className="game__inner">
                    {boxes.map((item) => (
                      <div
                        className={`gameItem ${
                          gameResultById[item]
                            ? gameResultById[item] === "B"
                              ? "bomb"
                              : "diamond"
                            : ""
                        }`}
                        style={boxStyle2(item)}
                      >
                        <div className="gameItem__inner" />
                        {gameResultById[item] && (
                          <div
                            className={`gameItem__solved ${
                              gameResultById[item] === "D"
                                ? "gameItem__diamond"
                                : "gameItem__bomb"
                            }`}
                            style={{
                              backgroundImage: `url(/mines/images/${
                                gameResultById[item] === "D"
                                  ? "blue-diamond.svg"
                                  : "bomb.svg"
                              })`,
                            }}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="tmpFooter--ju5rL">
                  <div>Thixpro Games • 1Tap Mines</div>
                  <div>
                    <LiveClock />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MineBody;
